/**
 * Two-column key/value grid used inside detail-page cards.
 * Pass an array of `{ label, value }` pairs. Falsy values render as "-".
 */
export function FieldGrid({ items }) {
  return (
    <dl
      style={{
        display: 'grid',
        gridTemplateColumns: 'minmax(120px, auto) 1fr',
        rowGap: 'var(--space-2)',
        columnGap: 'var(--space-4)',
        margin: 0,
      }}
    >
      {items.map((item) => (
        <Row key={item.label} label={item.label} value={item.value} />
      ))}
    </dl>
  );
}

function Row({ label, value }) {
  return (
    <>
      <dt className="muted text-sm" style={{ margin: 0 }}>{label}</dt>
      <dd style={{ margin: 0 }}>{value || '-'}</dd>
    </>
  );
}
